import React from 'react';
import { DirectiveData } from '../interfaces';

interface FlagSelectorProps {
  /** Directive data object containing type and parameters */
  directiveData: DirectiveData;
  /** Callback when directive data is updated */
  onUpdate: (updates: Partial<Omit<DirectiveData, 'id'>>) => void;
}

/**
 * Minimal React component for visibility flag directive.
 * Dropdown for predefined visibility flag options.
 */
export const FlagSelector: React.FC<FlagSelectorProps> = ({
  directiveData,
  onUpdate
}) => {
  // Safely access flag with fallback to empty string
  const flag = (directiveData.params?.flag as string) || '';

  return (
    <div className="field-group">
      <label className="field-label">Flag</label>
      <select
        name="flag"
        value={flag}
        onChange={(e) => onUpdate({ params: { ...directiveData.params, flag: e.target.value } })}
      >
        <option value="">Select flag...</option>
        <option value="hideDisconnectedBuiltIns">Hide disconnected built ins.</option>
        <option value="hideDisconnected">Hide all disconnected.</option>
      </select>
    </div>
  );
};
